import AccordionClass from "../html/accordion.js";
import TabsClass from "../html/tabs.js";
import {cleanupSerial} from "../../calcsys.js";
import CardClass from "../html/card.js";
import Item from './Email/message.js'


export default class SystemRules {

    ctx

    notif

    emailList
    tableData
    savedFilters
    filterTableData
    priorityTableData

    constructor() {

        let ctx = this.ctx = $('#EmailFiltersContainer')

        if(ctx.length > 0){

        }

    }

    setFilterTableData(x){
        this.filterTableData = x
    }
    setPriorityTableData(x){
        this.priorityTableData = x
    }

    setSavedFilters(x){
        this.savedFilters = x
    }

    init(tableData) {
        this.tableData = tableData
        let Tabs = new TabsClass(this.ctx, {'vertical': false})

        Tabs.addTab('SUMMARY', this.priorityPage())
        Tabs.addTab('NEW', this.filterTab())

        for(let i of this.savedFilters){
            Tabs.addTab(i.name, this.filterTab(i))

        }



    }

    priorityPage(){
        let table = new CS.MiniTable(this.priorityTableData, this.savedFilters, {'addRow': false})


        return table.getHTML()
    }

    filterTab(data={}){
        let table = new CS.MiniTable(this.filterTableData, data.data??[], {'showHeader': false})

        // let table = $('<div>')
        //
        // let y = new QueryBuilder(table,this.queryOptions)
        //
        // y.init()


        let emailList = $('<div>')
        let countDisplay = $('<div>').addClass('me-5 border border-1 px-1').html('-')
        let queryDisplay = $('<div>').addClass('me-5 border border-1 px-1').html('-')
        let resultFooter = $('<div>').addClass('hstack gap-2').append('Count: ',countDisplay,'Query: ', queryDisplay)
        let emailListCard = (new CardClass).createCard({
            'title': 'Test Results',
            'text': emailList,
            'footer': resultFooter,

        })

        let inps = $('<div>').addClass('inputContainer')
            .append(
            CS.createFromInput({
                'title': 'Name',
                'name': 'name',
                'type': 'text',
                'value': data.name??'',

            }),
            CS.createFromInput({
                'title': 'Type',
                'name': 'type',
                'type': 'text',
                'value': data.type??'',
            }),
                $('<input name="id" type="hidden" />').val(data.id),
        )
        //
        // let buttons = $('<div>').append(
        //     $('<div>').html('Count').addClass('btn btn-sm btn-info').on('click', ()=>{
        //         this.notif = CS.showInfo('Loading...')
        //         CS.ajaxCall({
        //             url: route('emails.search'),
        //             data: this.collectData(out),
        //         }, (r)=> { this.handleRespose(r)} )
        //     }),
        //     $('<div>').html('Get').addClass('btn btn-sm btn-danger').on('click', ()=>{
        //     this.notif = CS.showInfo('Loading...')
        //     let d = this.collectData(out)
        //     d.get = true
        //     CS.ajaxCall({
        //         url: route('emails.search'),
        //         data: d,
        //     }, (r)=> {
        //         this.handleRespose(r)
        //
        //     })
        // }),
        //
        // )

        let props = (new CardClass).createCard({
            'title': 'Properties',
            'text': inps,
            'buttons': [{
                'onClick': ()=>{
                    let d = this.collectData(out)

                    CS.ajaxCall({
                        url: route('emails.filter.save'),
                        data: d,
                    }, (r)=> {
                        this.notif = CS.showSuccess('Saved')

                    } )
                },
                'class': 'btn-success',
                'text': 'Save'
            }]


        })

        let postSave = (r) => {
            countDisplay.html(r.count??'-')
            queryDisplay.html(r.query??'-')

            if(r.error){
                emailList.html(r.error)

            }
            else if (r.msgs) {
                emailList.html('off')//this.renderEmailList(r.msgs))
            }else{
                emailList.html('SUCCESS!')
            }
        }

        let bidIDInput = $('<input>')

        let left = $('<div>').addClass('col-4')
            .append(props, (new CardClass).createCard({
                'title': 'Testing',
                'text': CS.createFromInput({
                    'title': 'Bid #',
                    'obj': bidIDInput,
                    'type': 'text',
                    'value': data.type??'',
                }),
                'buttons': [{
                    'onClick': ()=>{
                        emailList.html('Working...')
                        let d = this.collectData(out)

                        CS.ajaxCall({
                            url: route('emails.search'),
                            data: d,
                        }, postSave)
                    },
                    'class': 'btn-warning',
                    'text': 'Quick Test'
                },{
                    'onClick': ()=>{
                        emailList.html('Working...')
                        let d = this.collectData(out)
                        d.get = true
                        CS.ajaxCall({
                            url: route('emails.search'),
                            data: d,
                        }, postSave
                        )
                    },
                    'class': 'btn-danger',
                    'text': 'Get Sample Data'
                },{
                    'onClick': ()=>{
                        let d = this.collectData(out)
                        d.get = true
                        d.bidID =  bidIDInput.val()
                        if(d.bidID === '') return
                        emailList.html('Working...')
                        CS.ajaxCall({
                            url: route('emails.search'),
                            data: d,
                        }, postSave

                        )
                    },
                    'class': 'btn-danger',
                    'text': 'Test with Bid #'
                }]
            }))
        let right = $('<div>').addClass('col')
            .append((new CardClass).createCard({
                'title': 'Rules',
                'text': table.getHTML(),
            }))



        let filterDataBox = $('<div>').addClass('row').append(left,right)

        let out = $('<div>').addClass('container-fluid ')
            .append(filterDataBox,emailListCard)

        return out
    }

    handleRespose(r){



    }

    renderEmailList(list) {
        let acc = new AccordionClass()
        $(list).each((k, msg) => {
            let title = new Item(msg)
            let cont = $('<div>')
            // let end =
            // let titleCont = $('<div>').addClass('hstack gap-3 w-100')
            //     .append(title)

            acc.add(title,cont)
        })

        return acc.html()
        // this.emailList.html()

    }

    collectData(context){
        let out = $('input, textarea, select',context).serializeArray()

        let rowData = [];
        $('.dataRow', context).each((i,v) => {
            let d = $(v).find('input, select, textarea').serializeArray()
            rowData.push(cleanupSerial(d))
        })

        let ret = {inputs: cleanupSerial(out), rowData: rowData}

        return ret
    }

    queryOptions =  {
        allow_empty: true,

        //default_filter: 'name',
        // sort_filters: true,

        optgroups: {
            core: {
                en: 'Core',
                fr: 'Coeur'
            }
        },

        plugins: {
            'bt-tooltip-errors': { delay: 100 },
            // 'sortable': null,
            // 'filter-description': { mode: 'bootbox' },
//      'chosen-selectpicker': null,
            'unique-filter': null,
            'bt-checkbox': { color: 'primary' },
            'invert': null,
            'not-group': null
        },

        // standard operators in custom optgroups
        operators: [
            { type: 'equal', optgroup: 'basic' },
            { type: 'not_equal', optgroup: 'basic' },
            { type: 'in', optgroup: 'basic' },
            { type: 'not_in', optgroup: 'basic' },
            { type: 'less', optgroup: 'numbers' },
            { type: 'less_or_equal', optgroup: 'numbers' },
            { type: 'greater', optgroup: 'numbers' },
            { type: 'greater_or_equal', optgroup: 'numbers' },
            { type: 'between', optgroup: 'numbers' },
            { type: 'not_between', optgroup: 'numbers' },
            { type: 'begins_with', optgroup: 'strings' },
            { type: 'not_begins_with', optgroup: 'strings' },
            { type: 'contains', optgroup: 'strings' },
            { type: 'not_contains', optgroup: 'strings' },
            { type: 'ends_with', optgroup: 'strings' },
            { type: 'not_ends_with', optgroup: 'strings' },
            { type: 'is_empty' },
            { type: 'is_not_empty' },
            { type: 'is_null' },
            { type: 'is_not_null' }
        ],

        filters: [
            /*
             * string with separator
             */
            {
                id: 'name',
                field: 'username',
                label: {
                    en: 'Name',
                    fr: 'Nom'
                },
                icon: 'bi-person-fill',
                value_separator: ',',
                type: 'string',
                optgroup: 'core',
                default_value: 'Mistic',
                size: 30,
                validation: {
                    allow_empty_value: true
                },
                unique: true
            },
            /*
             * integer with separator for 'in' and 'not_in'
             */
            {
                id: 'age',
                label: 'Age',
                icon: 'bi-calendar3',
                type: 'integer',
                input: 'text',
                value_separator: '|',
                optgroup: 'core',
                description: function(rule) {
                    if (rule.operator && ['in', 'not_in'].indexOf(rule.operator.type) !== -1) {
                        return 'Use a pipe (|) to separate multiple values with "in" and "not in" operators';
                    }
                }
            },
            /*
             * textarea
             */
            {
                id: 'bson',
                label: 'BSON',
                icon: 'bi-qr-code',
                type: 'string',
                input: 'textarea',
                operators: ['equal'],
                size: 30,
                rows: 3
            },
            /*
             * checkbox
             */
            {
                id: 'category',
                label: 'Category',
                icon: 'bi-list-task',
                type: 'integer',
                input: 'checkbox',
                optgroup: 'core',
                values: {
                    1: 'Books',
                    2: 'Movies',
                    3: 'Music',
                    4: 'Tools',
                    5: 'Goodies',
                    6: 'Clothes'
                },
                colors: {
                    1: 'foo',
                    2: 'warning',
                    5: 'success'
                },
                operators: ['equal', 'not_equal', 'in', 'not_in', 'is_null', 'is_not_null'],
                default_operator: 'in'
            },
            /*
             * select
             */
            {
                id: 'continent',
                label: 'Continent',
                icon: 'bi-globe-americas',
                type: 'string',
                input: 'select',
                optgroup: 'core',
                placeholder: 'Select something',
                values: [
                    {
                        label: 'Europe',
                        value: 'eur',
                        optgroup: 'North'
                    },
                    {
                        label: 'Asia',
                        value: 'asia',
                        optgroup: 'North'
                    },
                    {
                        label: 'Oceania',
                        value: 'oce',
                        optgroup: 'South'
                    },
                    {
                        label: 'Africa',
                        value: 'afr',
                        optgroup: 'South'
                    },
                    {
                        label: 'North America',
                        value: 'na',
                        optgroup: 'North'
                    },
                    {
                        label: 'South America',
                        value: 'sa',
                        optgroup: 'South'
                    },
                    {
                        label: 'Mordor',
                        value: 'mrd'
                    }
                ],
                operators: ['equal', 'not_equal', 'is_null', 'is_not_null']
            },
            /*
             * Selectize
             */
            {
                id: 'state',
                label: 'State',
                icon: 'bi-globe-americas',
                type: 'string',
                input: 'select',
                multiple: true,
                plugin: 'selectize',
                plugin_config: {
                    valueField: 'id',
                    labelField: 'name',
                    searchField: 'name',
                    sortField: 'name',
                    options: [
                        { id: "AL", name: "Alabama" },
                        { id: "AK", name: "Alaska" },
                        { id: "AZ", name: "Arizona" },
                        { id: "AR", name: "Arkansas" },
                        { id: "CA", name: "California" },
                        { id: "CO", name: "Colorado" },
                        { id: "CT", name: "Connecticut" },
                        { id: "DE", name: "Delaware" },
                        { id: "DC", name: "District of Columbia" },
                        { id: "FL", name: "Florida" },
                        { id: "GA", name: "Georgia" },
                        { id: "HI", name: "Hawaii" },
                        { id: "ID", name: "Idaho" }
                    ]
                },
                valueSetter: function(rule, value) {
                    rule.$el.find('.rule-value-container select')[0].selectize.setValue(value);
                }
            },
            /*
             * radio
             */
            {
                id: 'in_stock',
                label: 'In stock',
                icon: 'bi-box-arrow-in-right',
                type: 'integer',
                input: 'radio',
                optgroup: 'plugin',
                values: {
                    1: 'Yes',
                    0: 'No'
                },
                operators: ['equal']
            },
            /*
             * double
             */
            {
                id: 'price',
                label: 'Price',
                icon: 'bi-currency-dollar',
                type: 'double',
                size: 5,
                validation: {
                    min: 0,
                    step: 0.01
                },
                data: {
                    class: 'com.example.PriceTag'
                }
            },
            /*
             * slider
             */
            {
                id: 'rate',
                label: 'Rate',
                icon: 'bi-box-arrow-lightning-charge-fill',
                type: 'integer',
                validation: {
                    min: 0,
                    max: 100
                },
                plugin: 'slider',
                plugin_config: {
                    min: 0,
                    max: 100,
                    value: 0
                },
                valueSetter: function(rule, value) {
                    var input = rule.$el.find('.rule-value-container input');
                    input.slider('setValue', value);
                    input.val(value); // don't know why I need it
                }
            },
            /*
             * placeholder and regex validation
             */
            {
                id: 'id',
                label: 'Identifier',
                icon: 'bi-sunglasses',
                type: 'string',
                optgroup: 'plugin',
                placeholder: '____-____-____',
                size: 14,
                operators: ['equal', 'not_equal'],
                validation: {
                    format: /^.{4}-.{4}-.{4}$/,
                    messages: {
                        format: 'Invalid format, expected: AAAA-AAAA-AAAA'
                    }
                }
            },
            /*
             * custom input
             */
            {
                id: 'coord',
                label: 'Coordinates',
                icon: 'bi-star',
                type: 'string',
                default_value: 'C.5',
                description: 'The letter is the cadran identifier:\
<ul>\
  <li><b>A</b>: alpha</li>\
  <li><b>B</b>: beta</li>\
  <li><b>C</b>: gamma</li>\
</ul>',
                validation: {
                    format: /^[A-C]{1}.[1-6]{1}$/
                },
                input: function(rule, name) {
                    var $container = rule.$el.find('.rule-value-container');

                    $container.on('change', '[name=' + name + '_1]', function() {
                        var h = '';

                        switch ($(this).val()) {
                            case 'A':
                                h = '<option value="-1">-</option> <option value="1">1</option> <option value="2">2</option>';
                                break;
                            case 'B':
                                h = '<option value="-1">-</option> <option value="3">3</option> <option value="4">4</option>';
                                break;
                            case 'C':
                                h = '<option value="-1">-</option> <option value="5">5</option> <option value="6">6</option>';
                                break;
                        }

                        $container.find('[name$=_2]')
                            .html(h).toggle(!!h)
                            .val('-1').trigger('change');
                    });

                    return '\
<select name="' + name + '_1"> \
  <option value="-1">-</option> \
  <option value="A">A</option> \
  <option value="B">B</option> \
  <option value="C">C</option> \
</select> \
<select name="' + name + '_2" style="display:none;"></select>';
                },
                valueGetter: function(rule) {
                    return rule.$el.find('.rule-value-container [name$=_1]').val()
                        + '.' + rule.$el.find('.rule-value-container [name$=_2]').val();
                },
                valueSetter: function(rule, value) {
                    if (rule.operator.nb_inputs > 0) {
                        var val = value.split('.');

                        rule.$el.find('.rule-value-container [name$=_1]').val(val[0]).trigger('change');
                        rule.$el.find('.rule-value-container [name$=_2]').val(val[1]).trigger('change');
                    }
                }
            }]
    }
}
